enum CarrierStatus {
  Completed = "completed",
  Failed = "failed",
  Pending = "pending",
  Verifying = "verifying",
  WaitingForUser = "waiting_for_user",
}

type CarrierStateInfo = {
  carrier_status: CarrierStatus;
  connect_url: string;
  session_id: string;
}

type CarrierVerification = {
  call_id?: string | null;
  carrier_states: Record<string, CarrierStateInfo>;
  container_id?: string | null;
  job_context_id?: string | null;
  user_id: string;
  verification_id: string;
  workflow_run_id?: string | null;
}

type LiveLink = {
  debugger_fullscreen_url: string;
  debugger_url: string;
  favicon_url: string;
  id: string;
  title: string;
  url: string;
}

export { CarrierStatus };

export type {
  CarrierStateInfo,
  CarrierVerification,
  LiveLink
}
